import Microsoft from "./Microsoft.svg";

export const MicrosoftIcon = () => {
  return <img src={Microsoft} />;
};
